/**
 * Filters Autocomplete Repository
 * Handles autocomplete API calls for cascading filters
 */

import { apiClient } from '../../client'

export interface AutocompleteItem {
    id: number
    en_name: string
}

export interface FiltersAutocompleteParams {
    type: 'category' | 'subcategory' | 'brand' | 'department' | 'bu' | 'client' | 'region' | 'city' | 'store' | 'sku' | 'user'
    search?: string
    filters?: {
        client_ids?: string
        bu_ids?: string
        department_ids?: string
        category_ids?: string
        subcategory_ids?: string
        brand_ids?: string
        region_ids?: string
        city_ids?: string
        store_ids?: string
        sku_ids?: string
    }
}

class FiltersAutocompleteRepository {
    /**
     * Get autocomplete results for filters
     * @param params - Autocomplete parameters including type, search, and filters
     * @returns Array of autocomplete items with id and en_name
     */
    async getAutocomplete(params: FiltersAutocompleteParams): Promise<AutocompleteItem[]> {
        // Send as POST request with JSON body
        const body = {
            type: params.type,
            ...(params.search && { search: params.search }),
            ...(params.filters && { filters: params.filters }),
        }

        return apiClient.post<AutocompleteItem[]>('/filters/autocomplete', body)
    }
}

export const filtersAutocompleteRepository = new FiltersAutocompleteRepository()
